export default "__VITE_ASSET__pXoxCP$4__"